exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".gallery .Drag-Drop{padding:25px;background-color:#eee;margin:0 0 35px;width:100%}.gallery .Drag-Drop .fa{font-size:50px;color:grey}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/dashboard/detail/gallery/gallery.scss
// module id = 592
// module chunks = 0